<div class="safari-a2hs-sheet" data-cy="safari-add-home-screen-sheet">
  <div class="sheet-header">
    <h2>{{ "safari-add-home-screen.title" | translate }}</h2>
    <button
      type="button"
      class="close-btn"
      (click)="close()"
      data-cy="safari-a2hs-close"
      [attr.aria-label]="'add-home-screen.close' | translate"
    >
      <mat-icon class="close-icon" aria-hidden="true">close</mat-icon>
    </button>
  </div>
  <p class="sheet-intro">{{ "safari-add-home-screen.intro" | translate }}</p>
  <ol class="steps">
    @for (step of steps; track step.titleKey; let i = $index) {
    <li class="step" [attr.data-cy]="'safari-a2hs-step-' + (i + 1)">
      <img [src]="step.image" [alt]="step.titleKey | translate" class="step-image" loading="lazy" />
      <div class="step-copy">
        <p class="step-title">{{ i + 1 }}. {{ step.titleKey | translate }}</p>
        <p class="step-body">{{ step.bodyKey | translate }}</p>
      </div>
    </li>
    }
  </ol>
  <ion-button class="done-btn" expand="block" (click)="close()" data-cy="safari-a2hs-done">
    {{ "safari-add-home-screen.done" | translate }}
  </ion-button>
</div>
